import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  HostBinding,
  Input,
  NgZone,
  OnInit,
  OnDestroy
} from '@angular/core';




import { Observable, merge } from 'rxjs';

import { HintsService } from './hints.service';
import { SegmentValidationService } from '../validation/segment-validation/segment-validation.service';
import { SegmentValidationItem } from '../validation/segment-validation/segment-validation-item.interface';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {debounceTime, distinctUntilChanged, takeWhile} from 'rxjs/operators';


@Directive({
  selector: '[hint]',
  exportAs: 'hints-directive'
})
export class HintsDirective implements OnInit, OnDestroy {

  @Input() hintText: string;

  @Input() hintExample: string;

  @Input() validation: SegmentValidationItem[];

  @Input() errorDetail: string;

  @Input() hintSubtitle: string;

  @HostBinding('class.hint-item') hintItem: boolean = true;

  private isHintActive: boolean = true;

  constructor(
    private hintsService: HintsService,
    private validationService: SegmentValidationService,
    private ngZone: NgZone,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.elementRef.nativeElement, 'click')
      .pipe(takeWhile(() => this.isHintActive))
      .subscribe((event: MouseEvent) => {
        this.showHint();
      });
      fromEvent(this.elementRef.nativeElement, 'focus')
      .pipe(takeWhile(() => this.isHintActive))
      .subscribe(() => {
        this.showHint();
      });
      if (!this.validation) { return; }
      const keydown = fromEvent(this.elementRef.nativeElement, 'keydown');
      const paste = fromEvent(this.elementRef.nativeElement, 'paste');
      merge(keydown, paste)
      .pipe(
          distinctUntilChanged(),
        debounceTime(100),
        takeWhile(() => this.isHintActive)
      )
      .subscribe((event: any) => {
        this.showValidation();
      });
    });
  }

  ngOnDestroy() {
    this.isHintActive = false;
  }

  private showHint(): void {
    this.hintsService.setHintText({
      hintText: this.hintText,
      hintExample: this.hintExample || '',
      hintSubtitle: this.hintSubtitle,
    });
    if (this.validation) { this.showValidation(); }
  }

  private showValidation() {
    this.validationService.setData(this.validation, this.errorDetail);
  }
}
